import React from 'react';
import i18n, { languageQueryParam, languages } from '@src/i18n';
import useStyles from './styles';
import { trackLanguageUpdate } from '@src/shared/tracking/language';
import useQueryParam from '@src/shared/hooks/use-queryparam';
import useActiveLanguage from '@src/shared/hooks/use-active-language';
import iconCheck from '@assets/icon-check-green.svg';
interface componentProps {
    onLanguageChanged: ()=> void
}
const LanguagePanel = (props : componentProps) => {
    const classes = useStyles();
    const { patchQueryParam } = useQueryParam(languageQueryParam);
    const { storedLanguageCode } = useActiveLanguage(true);
    const changeLang = (lang: string) => {
        trackLanguageUpdate(lang);
        i18n.changeLanguage(lang);
        patchQueryParam(languageQueryParam, lang);
        props.onLanguageChanged()
      };
   return <>
        <div className={`${classes.content} language-selector-content`}>
          <ul className={classes.langList}>
            {Object.keys(languages).map((key) => {
              const lang = languages[key];
              return lang.enabled ? (
                <li key={key} className={classes.langListItem}>
                  <button
                    type="button"
                    onClick={() => {
                      changeLang(key);
                    }}
                  >
                    <img
                      src={lang.img}
                      alt={lang.title}
                      className="icon-flag"
                    />
                    {lang.title}
                    {key === storedLanguageCode ? (
                      <img
                        src={iconCheck}
                        alt={lang.title}
                        className="icon-active"
                      />
                    ) : null}
                  </button>
                </li>
              ) : null;
            })}
          </ul>
        </div>
   </>
}

export default LanguagePanel
